// extracted by mini-css-extract-plugin
export default {"girlImage":"GirlImage_girlImage__Isw-N"};